import { MouseEvent, ReactNode } from "react"
import cc from "classcat"
import { Icon } from "./Icon"

interface Props {
  children?: ReactNode
  className?: string
  disabled?: boolean
  href?: string
  iconLeft?: string
  iconRight?: string
  onClick?: (event: MouseEvent) => void
  size?: "small" | "large"
  type?: "button" | "submit" | "reset"
  variant?: "emphatic" | "minimal" | "inverted" | "text" | "text-inverted"
}

export const Button = ({
  children,
  className,
  disabled,
  href,
  iconLeft,
  iconRight,
  onClick,
  size,
  type,
  variant,
}: Props) => {
  const Tag = href ? "a" : "button"

  return (
    <Tag
      type={type}
      className={cc([
        "btn",
        variant && `btn--${variant}`,
        size && `btn--${size}`,
        className,
      ])}
      onClick={onClick}
      {...(disabled ? { "aria-disabled": "true", disabled: true } : {})}
    >
      {iconLeft && (
        <Icon name={iconLeft} className="btn__icon btn__icon--left" />
      )}
      {children}
      {iconRight && (
        <Icon name={iconRight} className="btn__icon btn__icon--right" />
      )}
    </Tag>
  )
}
